import React from "react";
import cx from 'classnames';
import { FormControl } from "react-bootstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import bt from '../../components/commonStyle.css';
import s from './SearchFilterPlans.css';



const SearchFilterPlans = ({
    handleSearchChange,
    tableFilter,
    placeholder,
    handleDropDown,
    selectedValue,
    containerClass
}) => {

    return (
        <div className={cx(bt.displayFlex, bt.alignCenter, bt.gap12, bt.flexWrap, bt.justifyContentSpaceBetween, containerClass)}>
            <FormControl
                type="text"
                placeholder={placeholder}
                onChange={(e) => handleSearchChange(e.target.value)}
                className={cx("commonSearchIconInput", s.searchFilterInput)}
            />
            <FormControl
                componentClass="select"
                onChange={handleDropDown}
                value={selectedValue || ""}
                className={cx('commonSelectField', s.searchFilterSelect)}
            >
                {tableFilter?.map(({ value, label }) => (
                    <option key={value} value={value}>
                        {label}
                    </option>
                ))}
            </FormControl>
        </div>
    );
};

export default withStyles(bt, s)(SearchFilterPlans);
